// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 19 22", width: "19", height: "22" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M592,319 L598,325 L592,325 L592,319 Z M590,319 L590,327 L598,327 L598,339 C598,340.104 597.104,341 596,341 L581,341 C579.896,341 579,340.104 579,339 L579,321 C579,319.896 579.896,319 581,319 L590,319 Z", transform: "translate(-579 -319)" })))));
};
Icon.displayName = 'Document19x22';
export default Icon;
//# sourceMappingURL=Document19x22.js.map